<!-- Translated: skip -->
<template lang="html">
  <div class="subFilter">
    <div class="container">
      <div class="column column-beds">
        <div class="label">Antal bäddar</div>
        <CounterButton class="small" :count="$store.state.accomodationsFilter.beds" @changedCount="awaitFilter({waitForUser: true, callback: function() { changeBeds($event); }});" />
      </div>
      <div class="column column-bedrooms">
        <div class="label">Antal Sovrum</div>
        <CounterButton class="small" :count="$store.state.accomodationsFilter.bedrooms" @changedCount="awaitFilter({waitForUser: true, callback: function() { changeRooms($event); }});" />
      </div>
      <!-- <div class="column">
        <OutlineButton label="Sök stuga" closeLabel="Stäng sök X" :class="{active: searchToggle}" icon="settings" :status="searchToggle" @clicked="toggleSearch" />
      </div> -->
      <div class="column">
        <SwitchButton store="sauna" icon="bastu" :iconscale="2" :value="$store.state.accomodationsFilter.sauna" :sync="true" :labels="{ checked: 'Bastu', unchecked: 'Bastu'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
      <div class="column" v-if="!SITE_CONFIG.settings.SettingLockTypes.active">
        <SwitchButton store="direct_incheck" icon="direkt-incheck-black" :iconscale="2" :value="$store.state.accomodationsFilter.direct_incheck" :sync="true" :labels="{ checked: 'Digital incheckning', unchecked: 'Digital incheckning'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
      <div class="column">
        <SwitchButton store="fireplace" icon="kamin" :iconscale="2" :value="$store.state.accomodationsFilter.fireplace" :sync="true" :labels="{ checked: 'Öppen spis', unchecked: 'Öppen spis'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
      <div class="column">
        <SwitchButton store="pets" icon="husdjur" :iconscale="2" :value="$store.state.accomodationsFilter.pets" :sync="true" :labels="{ checked: 'Husdjur', unchecked: 'Husdjur'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
      <div class="column">
        <SwitchButton store="dishwasher" icon="diskmaskin" :iconscale="2" :value="$store.state.accomodationsFilter.dishwasher" :sync="true" :labels="{ checked: 'Diskmaskin', unchecked: 'Diskmaskin'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
      <div class="column">
        <SwitchButton store="dryer_cabinet" icon="torkskap-blue" :iconscale="2" :value="$store.state.accomodationsFilter.dryer_cabinet" :sync="true" :labels="{ checked: 'Torkskåp', unchecked: 'Torkskåp'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
      <div class="column">
        <SwitchButton store="washing_machine" icon="tvattmaskin" :iconscale="2" :value="$store.state.accomodationsFilter.washing_machine" :sync="true" :labels="{ checked: 'Tvättmaskin', unchecked: 'Tvättmaskin'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
      <div class="column" v-if="SITE_CONFIG.accomodations.filters.chargeStation">
          <SwitchButton store="chargeStation" icon="laddstolpe" :iconscale="2.3" :value="$store.state.accomodationsFilter.chargeStation" :sync="true" :labels="{ checked: 'Laddstolpe', unchecked: 'Laddstolpe'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
      <div class="column">
        <SwitchButton store="cleaning" icon="stadning" :iconscale="2" :value="$store.state.accomodationsFilter.cleaning" :sync="true" :labels="{ checked: 'Slutstäd ingår', unchecked: 'Slutstäd ingår i priset'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
      <div class="column" v-if="SITE_CONFIG.accomodations.filters.childFriendly">
        <SwitchButton store="child_friendly" icon="smiley-blue" :iconscale="2" :value="$store.state.accomodationsFilter.child_friendly" :sync="true" :labels="{ checked: 'Extra barnanpassat', unchecked: 'Extra barnanpassat'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
      <div class="column">
        <SwitchButton store="internet" icon="wifi-blue" :iconscale="2" :value="$store.state.accomodationsFilter.internet" :sync="true" :labels="{ checked: 'Wi-Fi', unchecked: 'Wi-Fi'}" @toggle="awaitFilter(); toggleFilterSwitch($event);" />
      </div>
    </div>
    <hr>
    <div class="container">
      <div class="column">
        <OutlineButton label="Välj via karta" closeLabel="Stäng karta" :status="mapToggle" :class="{active: mapToggle}" icon="map" :iconscale="2" @clicked="openMap" />
      </div>
      <div class="column flex-grow">
        <TextInput placeholder="Sök på stugnamn/område" :value="getFreeSearch" @change="changeFreeSearch" />
      </div>

    </div>
    <!-- <SearchModal v-show="searchToggle" @close="toggleSearch" /> -->
    <!-- <MapModal v-show="mapToggle" @close="toggleMap" /> -->

  </div>
</template>

<script>
import OutlineButton from '@/components/deprecated/OutlineButton';
import CounterButton from '@/components/components/CounterButton';
import SwitchButton from '@/components/components/SwitchButton';
import SearchModal from '@/components/parts/Accomodation/List/SearchModal';
import TextInput from '@/components/components/TextInput';

import { mapMutations, mapGetters } from 'vuex';

export default {
  components: { CounterButton, SwitchButton, OutlineButton, SearchModal, TextInput },
  computed: {
    ...mapGetters([
      'roomsCount',
      'searchToggle',
      'mapToggle',
      'getFreeSearch',
    ]),
  },
  methods: {
    ...mapMutations([
      'changeBeds',
      'changeRooms',
      'toggleSearch',
      'toggleFilterSwitch',
      'toggleMap',
      'changeFreeSearch',
      'openModal',
      'awaitFilter',
    ]),
    openMap() {
      this.openModal([`MapModal${this.SITE_CONFIG.site}`, {
        areaId: (this.$store.state.accomodationsFilter.locationId || null),
        type: 'interactive',
      }]);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'



.subFilter
  width 100%
  background-color rgba(236, 245, 248, 0.8)

.container
  max-width container-width
  margin 0 auto
  padding 10px 80px
  display flex
  flex-wrap wrap
  // justify-content space-between
  +max-mobile()
    padding-left padding-mobile
    padding-right padding-mobile

.label
  font-family Interstate
  font-size 11px
  font-weight bold
  letter-spacing 0.3px
  color #1c1c1c
  text-transform uppercase
  margin-bottom space-1
  text-align center

.column
  padding 10px
  box-sizing border-box
  min-width 25%
  width 50%
  +max-mobile()
    width 50%
  +max-screen(500px)
    width 100%
  .field
    border-width 1px



  // flex-shrink 1
  // flex-grow 1

.row
  margin-bottom 20px

.flex-grow
  flex-grow 2

hr
  border-bottom 2px solid white
  max-width 785px

.column-beds
  display none
  +max-xs-mobile()
    display block

.column-bedrooms
  display none
  +max-xs-mobile()
    display block
</style>



// WEBPACK FOOTER //
// AccomodationsFilterSub.vue?6e3db3ae